module.exports = __webpack_public_path__ + "img/0-md.19c9d726.jpg";